/**
 * Wire "Filter by Vehicle" sidebar toggles to localStorage so shoppers can
 * turn collection tag fitment on/off without clearing My Garage.
 */
(function () {
  var OFF_KEY = 'auto101_vehicle_collection_tag_filter_off';

  function readVehicle() {
    try {
      return JSON.parse(localStorage.getItem('selected_vehicle') || 'null');
    } catch (e) {
      return null;
    }
  }

  function vehicleReady() {
    var v = readVehicle();
    return !!(v && v.year && v.make && v.model);
  }

  function handleize(str) {
    return str
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-|-$/g, '');
  }

  function buildVehicleTagPath(collectionUrl, vehicle) {
    if (!collectionUrl || !vehicle) return null;
    var baseModel = vehicle.baseModel || vehicle.model;
    var yearTag = handleize('year:' + vehicle.year);
    var makeTag = handleize('make:' + vehicle.make);
    var modelTag = handleize('model:' + baseModel);
    return collectionUrl + '/' + yearTag + '+' + makeTag + '+' + modelTag;
  }

  function collectionUrlFromDom() {
    var el = document.getElementById('auto101-collection-url-for-toggle');
    if (!el || !el.textContent) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function setKnob(filterOn) {
    var bgOn = '#22c55e';
    var bgOff = '#94a3b8';
    var knobRight = '22px';
    var knobLeft = '2px';
    [
      ['vehicle-filter-toggle', 'vehicle-filter-knob'],
      ['vehicle-filter-toggle-mob', 'vehicle-filter-knob-mob'],
    ].forEach(function (pair) {
      var track = document.getElementById(pair[0]);
      var knob = document.getElementById(pair[1]);
      if (track) track.style.background = filterOn ? bgOn : bgOff;
      if (knob) knob.style.left = filterOn ? knobRight : knobLeft;
    });
  }

  function syncFromStorage() {
    if (!vehicleReady()) return;
    var off = localStorage.getItem(OFF_KEY) === '1';
    setKnob(!off);
  }

  function onToggleActivate(e) {
    e.preventDefault();
    e.stopPropagation();
    if (!vehicleReady()) return;

    var collectionUrl = collectionUrlFromDom();
    var vehicle = readVehicle();
    var filterPath = buildVehicleTagPath(collectionUrl, vehicle);
    var isOff = localStorage.getItem(OFF_KEY) === '1';
    var onCollection = window.location.pathname.indexOf('/collections/') !== -1;

    if (isOff) {
      localStorage.removeItem(OFF_KEY);
      syncFromStorage();
      if (onCollection && filterPath) {
        window.location.href = filterPath;
      } else {
        window.location.reload();
      }
    } else {
      localStorage.setItem(OFF_KEY, '1');
      syncFromStorage();
      if (onCollection && collectionUrl) {
        window.location.href = collectionUrl;
      } else {
        window.location.reload();
      }
    }
  }

  function bind() {
    ['vehicle-filter-toggle', 'vehicle-filter-toggle-mob'].forEach(function (id) {
      var el = document.getElementById(id);
      if (!el || el.dataset.auto101Bound === '1') return;
      el.dataset.auto101Bound = '1';
      el.setAttribute('role', 'button');
      el.setAttribute('tabindex', '0');
      el.setAttribute('aria-label', 'Toggle vehicle tag filter');
      el.addEventListener('click', onToggleActivate);
      el.addEventListener('keydown', function (ev) {
        if (ev.key === 'Enter' || ev.key === ' ') {
          ev.preventDefault();
          onToggleActivate(ev);
        }
      });
    });
    syncFromStorage();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }

  document.addEventListener('shopify:section:load', bind);
  window.addEventListener('auto101:garage-changed', function () {
    if (!vehicleReady()) {
      try {
        localStorage.removeItem(OFF_KEY);
      } catch (err) {}
    }
    bind();
  });
})();
